@if (scrollToTopVisible()) {
    <pnyc-button class="scroll-to-top" [title]="'SCROLL_TO_TOP.TITLES.TO_TOP'" [iconName]="'arrow-up'"
        [appearanceType]="'flat'" (clicked)="onScrollToTop()">
    </pnyc-button>
}